<div class="grid-x">
    <div class="cell small-12">
        <label for="buttonLabel">Button Label:</label>
        <input type="text" [(ngModel)]="buttonText" id="buttonLabel" />
    </div>
</div>